import React, { useState, useEffect, useCallback } from 'react';
import { Formik } from 'formik';
import bem from 'utils/bem';

import validationSchema from './validationSchema';

import Form from './Form';

import Model from '../../../../model';
import OrderFormSuccess from 'forms/forms/OrderForm/OrderFormSuccess';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-hot-toast';
import { createOrder } from 'api/orders';
import { createTicket } from 'api/tickets';

const { block } = bem('order-form', 'form');

const defaultValues = {
    customerPhone: '',
    customerName: '',
    customerSurname: '',
    customerEmail: '',
    customerSex: 'M',
    customerBirthday: '',
    customerSkype: '',
    comment: '',
    events: [],
    customerFound: false,
    ticketType: '',
    saleSum: 0,
    pairVisit: false,
    workingOffline: false //for validation purposes
};

const OrderForm = () => {

    const [ initialValues, setInitialValues ] = useState(defaultValues);
    const { setSubmitting, order, setOrder, init, reset, workingWithPairs, ticketType } = Model.orderForm;
    const { closeOrderForm } = Model.modal;

    useEffect(() => {
        init();
        return () => {
            reset();
        }
    }, []);

    const reopen = useCallback(() => {
        reset();
        init();
    }, []);

    const onSubmit = async (values, bag) => {

        values.pairVisit = !!workingWithPairs;
        values.ticketType = ticketType;

        const submitForm = () => {
            if (values.events.length === 1) {
                return createOrder({ ...values, event: values.events[0] })
            } else {
                return createTicket(values);
            }
        }

        try {
            setSubmitting(true);
            const { order, payUrl, paymentStatus, error } = await submitForm();
            setSubmitting(false);
            Model.user.updateUserInfo();
            if (paymentStatus === 'A_1' && !payUrl) {
                setOrder(order);
                Model.user.orders.unshift(order);
                bag.resetForm();
                return;
            }
            if (error) {
                throw error;
            }
            if (payUrl) {
                window.location.href = payUrl;
            } else {
                throw `payUrl is null`;
            }
        } catch (err) {
            console.log(err);
            toast.error(`Произошла ошибка: ${ err }`);
        }
    };

    if (order) {
        return <OrderFormSuccess order={ order } onOrderMoreClick={ reopen } onClose={ closeOrderForm }/>
    }

    return <div className={ block() }>
        <Formik
            initialValues={ initialValues }
            validationSchema={ validationSchema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmit }
            enableReinitialize={ true }
        >
            { form => {
                return <Form handleSubmit={ form.handleSubmit }/>
            }}
        </Formik>
    </div>
};

export default observer(OrderForm);
